import { Content } from "./content.js";

const contentElems = [...document.querySelectorAll(".img-anim")];
contentElems.forEach((el) => new Content(el));
